module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-0b6f2f36c8d3981850a76031325ef8b8.png";